"use strict";

var debug = require('debug')('algorithm:error');
var digitsIncrementChecker = require('./digits-increment-checker');


function fillString(str, len){
  while (str.length < len) {
    str = "0" + str;
  }
  return str;
}

function getMaximumIntegerIncrement(config, result) {
  var maximumIncrement = 10;
  var reliabilityFor1 = 0, reliabilityFor10 = 0, reliabilityFor100 = 0;
  for (var i = 0; i < result.length;  i++) {
    if (result[i].precision == 1) {
      reliabilityFor1 = result[i].reliability;
    }
    if (result[i].precision == 10) {
      reliabilityFor10 = result[i].reliability;
    }
    if (result[i].precision == 100) {
      reliabilityFor100 = result[i].reliability;
    }
  }
  if (reliabilityFor10 >= 50 && reliabilityFor1 >= 50) {
    maximumIncrement = 100;
  }

  if (config.digits && config.digits.maximumIntegerIncrement) {
    maximumIncrement = config.digits.maximumIntegerIncrement;
  }
  return maximumIncrement;
}

function getMaximumDecimalIncrement(config) {
  var maximumIncrement = 0.9;
  if (config.digits && config.digits.maximumDecimalIncrement) {
    maximumIncrement = config.digits.maximumDecimalIncrement;
  }
  return maximumIncrement;
}

function buildRawValue(result) {
  var res = [];
  for (var i = 0; i < result.length;  i++) {
    res.push(result[i].result);
  }
  return res;
}

function round4digits(val) {
  return Math.round(val * 10000) / 10000;
}

/* Return unit m3*/
var calculateValue = function(value, previousValue, result) {
  // we rely that highest precision is last (right) item in config and meter
  var lowestprecision = result[0].precision;
  var highestprecision = result[result.length - 1].precision;

  if (!previousValue) return value;

  // fetch away part that can be used for rolling next number:
  //  eg: previousValue = 2.4567, lowestprecision = 0.1  -> numberForRolling = 2
  //  eg: previousValue = 2.4567, lowestprecision = 0.01  -> numberForRolling = 2.4
  var numberForRolling = Math.floor(previousValue / (lowestprecision * 10)) * (lowestprecision * 10)
  var previousDecimalValue = previousValue - numberForRolling;
  if (round4digits(value) >= round4digits(previousDecimalValue)) {
    return round4digits(numberForRolling + value);
  } else {
    return round4digits((numberForRolling + (lowestprecision * 10) + value));
  }
}

/* Return unit m3 and reliability (0...1)*/
exports.buildInteger = function(result, config) {
  var val = null, err = null, errorCode = 0;
  var i;
  var previousValueString = "";
  if (!config.digits) {config.digits = {}}
  if (typeof config.previousDigitsIntegerValue === 'number') {
    previousValueString = config.previousDigitsIntegerValue.toString();
  }

  if (previousValueString.length > result.length) {
    debug("previousValue has more digits than expected");
    return {reliability:0, value:null, errorCode:4, rawValue:buildRawValue(result)};
  }

  // NOTE:currently this works only when digits does not have decimal part
  for (i = result.length - 1; i >= 0; i--) {
    if (result[i].result < 0) { // break from for loop when digit is not recognized
      break;
    }
    val += result[i].result * result[i].precision;
  }
  var digitsDetected = (result.length - (i + 1));
  // calculate reliability, it's just based on how many digits are recognized from right to left
  var reliability = digitsDetected / result.length;

  if (reliability < 1 && (config.previousDigitsIntegerValue === 0 || !(typeof config.previousDigitsIntegerValue === 'number'))) {
    val = null;
  } else if (reliability < 1 && reliability > 0) {
    // now we have to figure out what the number is

    // if previousValue is shorter than digit count -> fill with zero
    previousValueString = fillString(previousValueString, result.length);

    var valueString = val.toString();
    // We need to make sure that value string is long enough: if detected 05 -> string has to be "05"
    valueString = fillString(valueString, digitsDetected);
    //console.log(valueString);
    var s1  =  previousValueString.slice(0, previousValueString.length - valueString.length);
    var s2  =  previousValueString.slice(previousValueString.length - valueString.length);
    //console.log(s1, s2, val, result[i])
    var v1 = parseInt(s1, 10) * result[i].precision;
    var v2 = parseInt(s2, 10);
    if (v2 <= val) {
      val = v1 + val;
    } else if (digitsIncrementChecker.isIncrementAllowed(result[i].precision)) {
      // v2 > val and unrecognized digit is allowed to be incremented
      val = v1 +  result[i].precision + val;
    } else {
      val = null;
    }

  } else if (reliability === 0) {
    val = null;
  }

  if (val != null) {
    val = parseInt(val, 10);
    if (typeof config.previousDigitsIntegerValue === 'number') {
      // check that value has not gone backward
      if (val < config.previousDigitsIntegerValue && val > 10 && !config.digits.allowBackwards) {
      // when meter is changed, we go backward, allow it for first 10m3
      // allowBackward is only for debugging purpose
        debug("Digits integer value went backward :" + (val - config.previousDigitsIntegerValue));
        errorCode = 5;
        val = null;
      } else if ((val - config.previousDigitsIntegerValue) > getMaximumIntegerIncrement(config, result)) { // check if value has grown too much
        debug("Digits integer value growth more than " + getMaximumIntegerIncrement(config, result) + " value:" + val + " previousValue:" + config.previousDigitsIntegerValue);
        errorCode = 2;
        val = null;
      }
    }
  } else {
    errorCode = 3;
    debug("Integer digits not readable");
  }

  return {reliability:reliability, value:val, errorCode:errorCode, rawValue:buildRawValue(result)};
}

function roundToPrecision(val, precision) {
  var multiplier = 1;
  switch (precision) {
  case 0.1:
    multiplier = 10;
    break;
  case 0.01:
    multiplier = 100;
    break;
  case 0.001:
    multiplier = 1000;
    break;
  case 0.0001:
    multiplier = 10000;
    break;
  }
  return Math.round(val * multiplier) / multiplier;
}
/* Return unit m3*/
exports.buildDecimal = function(result, config) {
  var val = 0, errorCode = 0;
  for (var i = 0; i < result.length; i++) {
    if (result[i].result < 0) { val = null; break;}
    val += result[i].result * result[i].precision;
  }
  if (val === null) {
    errorCode = 3;
    debug("Decimal digits not readable");
  } else {
    val = calculateValue(val, config.previousDigitsDecimalValue, result)
    val = roundToPrecision(val, result[result.length - 1].precision);
    if (typeof config.previousDigitsDecimalValue === 'number' && Math.abs(val - config.previousDigitsDecimalValue) > getMaximumDecimalIncrement(config)) {
      debug("Decimal integer value growth more than " + getMaximumDecimalIncrement(config) + " value:" + val + " previousValue:" + config.previousDigitsDecimalValue);
      errorCode = 2;
      val = null;
    }
  }

  return {value:val, errorCode:errorCode, rawValue:buildRawValue(result)};
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/build-digits.js
// module id = 838
// module chunks = 0